import { useEffect, useState } from "react";
import { ConfiguredSalesDisplaySlide } from "@/components/display/ConfiguredSalesDisplaySlide";
import {
  SALES_DISPLAY_DRAFT_READY,
  isSalesDisplayDraftMessage,
  type SalesDisplayDraftMessage,
} from "@/lib/sales-display-preview";
import type { SalesDisplaySlide } from "@/lib/sales-display-slides";

/**
 * VIB-2705: previewflate for sliden som holder på å bli skrevet.
 *
 * Denne ruta finnes kun for å bli lastet i en iframe fra slideoppsettet. Den
 * henter ingen data og viser ingenting før den får et utkast via postMessage —
 * utkastet er ikke lagret, så det kan ikke slås opp.
 *
 * Hvorfor en egen rute og ikke bare komponenten rett i innstillinger: se
 * forklaringen på SALES_DISPLAY_PREVIEW_WIDTH i `sales-display-preview.ts`.
 * Kort fortalt måles `vw` i skriftstørrelsen mot vindusbredden, og bare inne i
 * en iframe er den bredden den samme som flata sliden vises på.
 *
 * Den er bevisst holdt utenfor SalesDisplayPage: den sida laster hele
 * salgsdashboardet, og et tekstutkast trenger ingenting av det.
 */
export default function SalesDisplayDraftPage() {
  const [slide, setSlide] = useState<SalesDisplaySlide | null>(null);

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (!isSalesDisplayDraftMessage(event.data)) return;
      setSlide((event.data as SalesDisplayDraftMessage).slide);
    };
    window.addEventListener("message", onMessage);
    // Si fra at flata lytter. Foreldren venter på dette før den sender, fordi
    // iframens `onLoad` fyrer før React har montert lytteren over.
    window.parent?.postMessage({ type: SALES_DISPLAY_DRAFT_READY }, window.location.origin);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return (
    <div className="relative h-screen w-screen overflow-hidden bg-[#081F3B]">
      {slide && <ConfiguredSalesDisplaySlide slide={slide} />}
    </div>
  );
}
